import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ISiteParamsApiListResponse, ISiteParamUpdateParams, ISiteParamUpdateResponse } from '@/types/siteParams';

export const siteParamsList = (siteId: number, config?: AxiosRequestConfig): Promise<AxiosResponse<ISiteParamsApiListResponse>> => {
    return axios.get('/api/siteParams/list', {
        ...config,
        params: { siteParamsSiteId: siteId },
    });
};

export const siteParamsCreate = (params: ISiteParamUpdateParams): Promise<AxiosResponse<ISiteParamUpdateResponse>> => {
    return axios.post('/api/siteParams/create', params);
};

export const siteParamsUpdate = (params: ISiteParamUpdateParams): Promise<AxiosResponse<ISiteParamUpdateResponse>> => {
    return axios.post('/api/siteParams/update', params);
};

export const siteParamsDelete = (params: ISiteParamUpdateParams): Promise<AxiosResponse<ISiteParamUpdateResponse>> => {
    return axios.post('/api/siteParams/delete', params);
};
